import styled from 'styled-components';

import { Colors } from 'theme/colors';
import { Container } from 'theme/layout';

import type { TextInputProps } from './styles.shared';
export {
  ClearText,
  InlineError,
  InputContainer,
  TextInput,
  SecureSwitch,
  TextInputProps,
} from './styles.shared';

export const InlineErrorContainer = styled(Container)<TextInputProps & { isVisible?: boolean }>`
  && {
    align-items: center;
    display: flex;
    background: ${Colors.lightGrey};
    border-top-right-radius: 7px;
    border-top-left-radius: 7px;
    flex-direction: row;
    padding: 8px;
    width: 100%;
    position: ${({ position }) => (position ? position : 'absolute')};
    top: -33px;
    left: 0px;
    right: 0px;
    z-index: -1;
    opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
    transform: ${({ isVisible }) => (isVisible ? 'translateY(0px)' : 'translateY(33px)')};
    transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  }

  @media (max-width: 40em) {
    position: static;
    top: unset;
    left: unset;
    right: unset;
    transform: ${({ isVisible }) => (isVisible ? 'translateY(0px)' : 'translateY(10px)')};
  }
`;
